export default "__VITE_ASSET__72834ccd__"